/**
 * Fichier de réexportation pour préserver la rétrocompatibilité des imports dans l'application.
 * Ce fichier réexporte toutes les constantes, interfaces, types et la classe WebSocket historique
 * (renommée en DmpWebSocketStrategyService) sous son ancien nom de classe DmpService.
 */

export * from './strategies/dmp-websocket.strategy';

import { DmpWebSocketStrategyService } from './strategies/dmp-websocket.strategy';
export { DmpWebSocketStrategyService as DmpService };
